import { Grid, Text, chakra } from '@chakra-ui/react';
import React from 'react';

import { GeneralSection, SectionType } from '@/layout';
import { SpecialtyFeature } from '@/views/business';

const SpecialtySection = () => (
  <GeneralSection
    name="specialty"
    sectionType={SectionType.LIGHT}
    title={
      <chakra.h2 textStyle="heading" mb="5" fontSize={{ base: `2.2rem`, md: `2.7rem` }}>
        이노앤엠만의{` `}
        <Text as="span" color="brand.300">
          특별함
        </Text>
      </chakra.h2>
    }
    titleTextUnderlineDividerProps={{ show: false }}
    titleWrapProps={{ mb: { base: `2rem`, md: `3rem` } }}
  >
    <Grid
      templateColumns={{ base: `repeat(1, 1fr)`, md: `repeat(3, 1fr)` }}
      gap={10}
      px={{ md: 12 }}
    >
      <SpecialtyFeature
        title="PARTNER"
        description="포털 사이트 뉴스 섹션에 노출되는 국내 주요 150여개 언론사와 제휴"
        iconUrl="/pages/business/media/sections/specialty/icon_1.png"
      />
      <SpecialtyFeature
        title="SPECIALTY"
        description="전문성으로 무장한 업종별 맞춤 고품질 원고로 콘텐츠를 생성합니다."
        iconUrl="/pages/business/media/sections/specialty/icon_2.png"
      />
      <SpecialtyFeature
        title="MESSAGE"
        description="브랜드 소식과 정보를 효과적으로 고객에게 전달합니다."
        iconUrl="/pages/business/media/sections/specialty/icon_3.png"
      />
    </Grid>
  </GeneralSection>
);

export default SpecialtySection;
